module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0816dfdfed40f2f7ace5cf90ad44bebc.png";